import { Pipe, PipeTransform } from '@angular/core';

import { SkyResources } from './resources';


export class SkyResourcesPipe implements PipeTransform {
  public transform(name: string): string {
    return SkyResources.getString(name);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'skyResources'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
